import { ContainerLink } from '@/components/atoms/CustomLink/CustomLink.styled';
import { ImageContainer } from '@/components/atoms/Image/Image.styled';
import { Typography } from '@/components/atoms/Typography/Typography.styled';
import { medias } from '@/utils/sizes';
import styled from 'styled-components';

export const TextExclusiveContent = styled.div`
  aspect-ratio: 4/5;
  box-sizing: border-box;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--spacing-component-inner-sm);
  width: 100%;
  aspect-ratio: 1.5;
  top: 0;
  opacity: 0;
  transition: opacity var(--tr-base);
  z-index: 100;
`

export const ArchiveGalleryContainer = styled.div`
  width: 100%;
  border-top: 1px solid var(--c-border);
  padding-bottom: var(--spacing-component-inner);

  .archived-batch-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: var(--spacing-component-inner);
    margin-bottom: 0 !important;
  }

  &[data-is-additional-list='true'] {
    border-top: none;
  }

  .loader-spinner {
    height: 30px;
    width: 30px !important;

    .loader-spinner-animate {
      border-width: 1px !important;
    }
  }

  > ${Typography} {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto 0;
    grid-column: 1 / -1;
    height: var(--spacing-component-sm);
    width: min-content;
  }

  ${ImageContainer} {
    width: 100%;
  }

  ${ContainerLink} {
    display: flex;
    flex-direction: column;
  }

  ${medias.min.tablet} {
    .archived-batch-container {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  iframe {
    pointer-events: none !important;
  }

  ${medias.min.desktopSm} {
    .archived-batch-container {
      grid-template-columns: repeat(6, 1fr);
    }
  }

  .archived-project-link:hover img {
    transform: scale(1.025);
  }

  .archived-project-link div {
    width: 100%;
  }

  .text-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: var(--spacing-component-inner-sm) 0;
    margin-bottom: var(--spacing-component-inner-sm);
  }

  .archived-project-link.disabled-link:hover {
    img, iframe {
      filter: blur(3px);
    }

    ${TextExclusiveContent} {
      opacity: 1;
    }
  }
`;